module.exports = __webpack_public_path__ + "media/review-badges/rank-25k-f40b3386.svg";